module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/default-article-4d311a36521066323a26d3b26c3afa42.png";